<template>
  <v-container>
    <testo1 v-if="idtesto == 1"></testo1>
    <testo2 v-if="idtesto == 2"></testo2>
  </v-container>
</template>

<script>
//import axios from "axios";
import testo1 from "@/components/testiHtml/1.vue";
import testo2 from "@/components/testiHtml/2.vue";

export default {
  name: "infofacolta",
  components: {
    testo1,
    testo2,
  },
  props: {
    idtesto: Number,
  },
  mounted() {
    //alert("parto:" + this.idtesto);
    //this.loadFile();
  },
  methods: {
    /*loadFile() {
      axios({
        method: "get",
        url: "${publicPath}assets/infoFac/3.html",
        baseURL: "/",
      })
        .then((result) => {
          this.compiledHTML = result.data;
        })
        .catch((error) => {
          alert("Errore:" + error);
        });
    },*/
  },
  data: () => ({
    compiledHTML: "",
  }),
};
</script>
